(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["LTIAnalytics"] = factory();
	else
		root["LTIAnalytics"] = factory();
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 332:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LTIAnalytics = /*#__PURE__*/function () {
  function LTIAnalytics() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, LTIAnalytics);
    this.version = '1.0.0';
    this.endpoint = null;
    this.apiKey = null;
    this.queue = [];
    this.sessionId = null;
    this.userId = null;
    this.config = {
      batchSize: 5,
      flushInterval: 3000,
      autoTrack: true,
      debug: false,
      trackPageVisibility: false
    };
    this.flushTimer = null;
    this.isIdentified = false;
  }
  return _createClass(LTIAnalytics, [{
    key: "init",
    value: function init(apiKey) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.apiKey = apiKey;
      this.endpoint = options.endpoint || 'http://localhost:8000/api/v1';
      this.config = _objectSpread(_objectSpread({}, this.config), options);

      // Generate or retrieve session
      this.sessionId = this.getOrCreateSession();

      // Check if user is already identified for this session
      this.checkIdentificationStatus();

      // Set up automatic tracking
      if (this.config.autoTrack) {
        this.setupAutoTracking();
      }

      // Start batch timer
      this.startBatchTimer();

      // Track page view on init
      this.pageview();
      if (this.config.debug) {
        console.log('LTI Analytics initialized', {
          apiKey: apiKey,
          endpoint: this.endpoint
        });
      }
    }
  }, {
    key: "getOrCreateSession",
    value: function getOrCreateSession() {
      var sessionKey = 'lti_session_id';
      var sessionId = this.getCookie(sessionKey);
      if (!sessionId) {
        sessionId = this.generateUUID();
        this.setCookie(sessionKey, sessionId, 30); // 30 days expiration
      }
      return sessionId;
    }
  }, {
    key: "generateUUID",
    value: function generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, {
    key: "track",
    value: function track(eventName) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.apiKey) {
        console.error('LTI Analytics: Must call init() before tracking');
        return;
      }
      var event = {
        event: eventName,
        properties: _objectSpread(_objectSpread({}, properties), {}, {
          $current_url: window.location.href,
          $referrer: document.referrer,
          $timestamp: Date.now()
        }),
        session_id: this.sessionId,
        user_id: this.userId
      };
      this.queue.push(event);
      if (this.queue.length >= this.config.batchSize) {
        this.flush();
      }
    }
  }, {
    key: "pageview",
    value: function pageview() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pageProperties = _objectSpread(_objectSpread({
        title: document.title,
        url: window.location.href,
        path: window.location.pathname,
        referrer: document.referrer
      }, this.getUTMParams()), properties);
      this.track('pageview', pageProperties);
    }
  }, {
    key: "identify",
    value: function identify(userId) {
      var _this = this;
      var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.isIdentified && this.userId === userId) {
        return;
      }
      this.userId = userId;
      var identifyEvent = {
        api_key: this.apiKey,
        user_id: userId,
        session_id: this.sessionId,
        traits: traits,
        timestamp: Date.now()
      };

      // Send identify immediately & save on success
      this.sendRequest('/identify', identifyEvent, function (response) {
        if (response.ok) {
          _this.isIdentified = true;
          var identifiedKey = "lti_identified_".concat(_this.sessionId);
          _this.setCookie(identifiedKey, userId, 30);
          if (_this.config.debug) {
            console.log('Identify successful', response);
          }
        } else {
          if (_this.config.debug) {
            console.log('Identify failed', response);
          }
        }
      });
    }
  }, {
    key: "getUTMParams",
    value: function getUTMParams() {
      var params = new URLSearchParams(window.location.search);
      var utm = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (param) {
        if (params.get(param)) {
          utm[param] = params.get(param);
        }
      });
      return utm;
    }
  }, {
    key: "setupAutoTracking",
    value: function setupAutoTracking() {
      var _this2 = this;
      // Track clicks on elements with data-track attribute
      document.addEventListener('click', function (e) {
        var trackable = e.target.closest('[data-track]');
        if (trackable) {
          var eventName = trackable.getAttribute('data-track');
          var properties = {};

          // Get all data-track-* attributes as properties
          Array.from(trackable.attributes).forEach(function (attr) {
            if (attr.name.startsWith('data-track-') && attr.name !== 'data-track') {
              var key = attr.name.replace('data-track-', '');
              properties[key] = attr.value;
            }
          });
          _this2.track(eventName, properties);
        }
      });

      // Track form submissions
      document.addEventListener('submit', function (e) {
        if (e.target.tagName === 'FORM') {
          var formName = e.target.getAttribute('name') || e.target.getAttribute('id') || 'unnamed_form';
          _this2.track('form_submitted', {
            form_name: formName,
            form_action: e.target.action
          });
        }
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          if (_this2.config.trackPageVisibility) {
            _this2.track('page_hidden');
          }
          _this2.flush(); // Flush events when page is hidden
        } else {
          if (_this2.config.trackPageVisibility) {
            _this2.track('page_visible');
          }
        }
      });

      // Flush on page unload
      window.addEventListener('beforeunload', function () {
        _this2.flush(true); // Force sync flush
      });
    }
  }, {
    key: "startBatchTimer",
    value: function startBatchTimer() {
      var _this3 = this;
      this.flushTimer = setInterval(function () {
        if (_this3.queue.length > 0) {
          _this3.flush();
        }
      }, this.config.flushInterval);
    }
  }, {
    key: "flush",
    value: function flush() {
      var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.queue.length === 0) return;
      var events = _toConsumableArray(this.queue);
      this.queue = [];
      var payload = {
        api_key: this.apiKey,
        events: events
      };
      if (sync && navigator.sendBeacon) {
        // Use sendBeacon for sync requests (page unload)
        var blob = new Blob([JSON.stringify(payload)], {
          type: 'application/json'
        });
        navigator.sendBeacon("".concat(this.endpoint, "/batch"), blob);
      } else {
        // Use fetch for async requests
        this.sendRequest('/batch', payload);
      }
    }
  }, {
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(path, data, callback) {
        var response, _this$queue, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return fetch("".concat(this.endpoint).concat(path), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              });
            case 1:
              response = _context.v;
              if (callback) {
                callback(response);
              }
              if (!response.ok && this.config.debug) {
                console.error('LTI Analytics: Request failed', response.status);
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              if (this.config.debug) {
                console.error('LTI Analytics: Network error', _t);
              }

              // Re-queue events on network error
              if (path === '/batch' && data.events) {
                (_this$queue = this.queue).unshift.apply(_this$queue, _toConsumableArray(data.events));
              }
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function sendRequest(_x, _x2, _x3) {
        return _sendRequest.apply(this, arguments);
      }
      return sendRequest;
    }() // Utility methods
  }, {
    key: "reset",
    value: function reset() {
      // Clear identification cookie for old session
      if (this.sessionId) {
        var oldIdentifiedKey = "lti_identified_".concat(this.sessionId);
        this.deleteCookie(oldIdentifiedKey);
      }
      this.userId = null;
      this.isIdentified = false;
      this.sessionId = this.generateUUID();
      this.setCookie('lti_session_id', this.sessionId, 30);
      this.queue = [];
    }
  }, {
    key: "debug",
    value: function debug() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.config.debug = enabled;
    }

    // Add these helper methods for cookie management
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      var value = "; ".concat(document.cookie);
      var parts = value.split("; ".concat(name, "="));
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }
  }, {
    key: "setCookie",
    value: function setCookie(name, value, days) {
      var expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

      // Set domain to allow cross-subdomain access
      var domain = this.getRootDomain();
      document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(expires.toUTCString(), ";path=/;domain=").concat(domain, ";SameSite=Lax");
    }
  }, {
    key: "getRootDomain",
    value: function getRootDomain() {
      var hostname = window.location.hostname;

      // If it's localhost or an IP address, don't set domain
      if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        return hostname;
      }

      // Extract root domain (e.g., "example.com" from "sub.example.com")
      var parts = hostname.split('.');
      if (parts.length > 2) {
        return ".".concat(parts.slice(-2).join('.'));
      }
      return ".".concat(hostname);
    }

    // Add method to delete cookies
  }, {
    key: "deleteCookie",
    value: function deleteCookie(name) {
      var domain = this.getRootDomain();
      document.cookie = "".concat(name, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=").concat(domain);
    }
  }, {
    key: "checkIdentificationStatus",
    value: function checkIdentificationStatus() {
      var identifiedKey = "lti_identified_".concat(this.sessionId);
      var identifiedUserId = this.getCookie(identifiedKey);
      if (identifiedUserId) {
        this.userId = identifiedUserId;
        this.isIdentified = true;
        if (this.config.debug) {
          console.log('LTI Analytics: User already identified for this session', identifiedUserId);
        }
      }
    }
  }]);
}();
var lti = new LTIAnalytics();

// Export for different module systems
if ( true && module.exports) {
  module.exports = lti;
} else if (true) {
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return lti;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else // removed by dead control flow
{}

// Also export the class if someone wants multiple instances
if (typeof window !== 'undefined') {
  window.LTIAnalyticsClass = LTIAnalytics;
}

// Export the singleton directly
module.exports = lti;
module.exports["default"] = lti;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(332);
/******/ 	__webpack_exports__ = __webpack_exports__["default"];
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});